import { Location } from '@angular/common'
import { Component } from '@angular/core'

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss']
})
export class UnauthorizedComponent {
  constructor(private _location: Location) {}

  goBack() {
    this._location.back()
  }
}
